module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_8004.e1d5ba87.png";